import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { HttpParams, HttpClient } from "@angular/common/http";
import { GlobalService } from "../services/global.service";
import { ConfigService } from "../services/config.service";
import { resolve } from "url";
@Injectable()
export class RestService {
  /* Live Service */
  // Service = {
  //   SSL: true,
  //   PORTS: [2053, 2083, 2096, 2087, 2085, 2086, 2084],
  //   IP: 'apiclient.msc.exchange',
  //   LIVE: true,
  //   ADMIN: 'apiadmin.msc.exchange/Exch_Admin',
  //   END_POINT: 'API_Clnt'
  // };

  /* Staging Server */
  Service = {
    SSL: false,
    PORTS: [2353, 2383, 2396, 2387, 2385, 2386, 2384, 4152], // BB,CHART,BK,TRADE,ACTIIVITY,BALANCE,ADM_BM,API_PORT
    IP: "162.253.17.115",
    ADMIN: "http://185.2.103.78:9101/QuoteStudioAPI",
    LIVE: false,
    END_POINT: "QuoteStudioAPI"
  };
  

 

  // config = {
  //   AppName: "Bitxtream",
  //   PrimaryUrl: "https://api.bitxtream.com/TraderroomAPI_bitxtream",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.bitxtream.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.bitxtream.com/"
  // };

  
  // config = {
  //   AppName: "leveragefx",
  //   PrimaryUrl: "https://api.leveragefx.org/Tradersroom_API_leveragefx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.leveragefx.org/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.leveragefx.org/"
  // };

  //   config = {
  //   AppName: "mvfx",
  //   PrimaryUrl: "https://api.mvfx.co.in/Tradersroom_API_mvfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.mvfx.co.in/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.mvfx.co.in/"
  // };

  // config = {
  //   AppName: "fxtradeomarket",
  //   PrimaryUrl: "https://api.fxtradeomarket.com/Tradersroom_API_fxtradeomarket",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxtradeomarket.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxtradeomarket.com/"
  // };

  // config = {
  //   AppName: "proficientfx",
  //   PrimaryUrl: "https://api.proficientfx.com/Tradersroom_API_proficientfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.proficientfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.proficientfx.com/"
  // };

  // config = {
  //   AppName: "365fxmarkets",
  //   PrimaryUrl: "https://api.365fxmarkets.com/Tradersroom_API_365fxmarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.365fxmarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.365fxmarkets.com/"
  // };

  // config = {
  //   AppName: "altawanafxmarket",
  //   PrimaryUrl: "https://api.altawanafxmarket.com/Tradersroom_API_altawanafxmarket",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: " https://client.altawanafxmarket.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.altawanafxmarket.com/"
  // };


  // config = {
  //   AppName: "carnivalcapitalsfx",
  //   PrimaryUrl: "https://apicarnival.carnivalcapitalsfx.com/Tradersroom_API_carnivalcapitalsfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.carnivalcapitalsfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.carnivalcapitalsfx.com/"
  // };

   // config = {
  //   AppName: "racfx",
  //   PrimaryUrl: "https://api.racfx.com/Tradersroom_API_racfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.racfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.racfx.com/"
  // };

  // config = {
  //   AppName: "credCapital",
  //   PrimaryUrl: "https://api.cred.capital/Tradersroom_API_cred.capital",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.cred.capital/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.cred.capital/"
  // }

// MAIN SERVICE 



  // config = {
  //   AppName: "client",
  //   PrimaryUrl: "http://178.238.234.59:8258/Tradersroom_API",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://crm.traderscabinet.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://crm.traderscabinet.com/"
  // }

  // config = {
  //   AppName: "client",
  //   PrimaryUrl: "https://api.cred.capital/Tradersroom_API_cred.capital",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.cred.capital/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.cred.capital/"
  // }
  
  
// Working-----
  config = {
    AppName: "traderscabinet",
    PrimaryUrl: "https://api.traderscabinet.com/Tradersroom_API_traderscabinet",
    //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
    SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
   Url: "https://v7.traderscabinet.com/assets/PHP/alfa/v1",
    AdminApi: "",
    base_url:"https://v7.traderscabinet.com/",
    MerchantRef: "ulo1mjib",
    API_Key: "s5co4l6a"
  };

  // config = {
  //   AppName: "fxtni",
  //   PrimaryUrl: "https://api.fxtni.com/Tradersroom_API_fxtni",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://fxtni.fxusolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://fxtni.fxusolutions.com/"
  // };


  // config = {
  //   AppName: "client.fxtni",
  //   PrimaryUrl: "https://api.fxtni.com/Tradersroom_API_fxtni",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxtni.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxtni.com/"
  // };


  // config = {
  //   AppName: "timexexchange",
  //   PrimaryUrl: "https://api.timexexchange.com/Tradersroom_API_timexexchange",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.timexexchange.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.timexexchange.com/"
  // };



  // config = {
  //   AppName: "acqafx",
  //   PrimaryUrl: "https://api.acqafx.com/Tradersroom_API_acqafx",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.acqafx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.acqafx.com/"
  // };


  // config = {
  //   AppName: "acqafx",
  //   PrimaryUrl: "https://api.acqafx.com/Tradersroom_API_acqafx",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.acqafx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.acqafx.com/"
  // };



  // config = {
  //   AppName: "aceliquidity",
  //   PrimaryUrl: "https://api.aceliquidity.com/Tradersroom_API_aceliquidity",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.aceliquidity.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.aceliquidity.com/"
  // };

  // config = {
  //   AppName: "fxcartage",
  //   PrimaryUrl: "https://api.fxcartage.com/Tradersroom_API_fxcartage",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxcartage.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxcartage.com/",
  //   MerchantRef:"",
  //     API_Key:""
  // };


  // config = {
  //   AppName: "indiecapitalmarket",
  //   PrimaryUrl: "https://api.indiecapitalmarket.com/Tradersroom_API_indiecapitalmarket",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.indiecapitalmarket.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.indiecapitalmarket.com/",
  //   MerchantRef:"",
  //     API_Key:""
  // };



  // config = {
  //   AppName: "fxcrt",
  //   PrimaryUrl: "https://api.fxcrt.com/Tradersroom_API_fxcrt",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxcrt.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxcrt.com/"
  // };

  // config = {
  //   AppName: "hb4x",
  //   PrimaryUrl: "https://api.hb4x.com/Tradersroom_API_hb4x",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.hb4x.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.hb4x.com/"
  // };

  // config = {
  //   AppName: "unityfxmarkets",
  //   PrimaryUrl: "https://api.unityfxmarkets.com/Tradersroom_API_unityfxmarkets",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.unityfxmarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.unityfxmarkets.com/#/auth/login/",
  //   base:"https://client.unityfxmarkets.com/#/auth/login?userId=abc123",
  //   MerchantRef:"7gnjiuo9",
  //   API_Key:"nlt3s35t"
  // };

  // config = {
  //   AppName: "prideforex",
  //   PrimaryUrl: "https://api.prideforex.asia/Tradersroom_API_prideforex",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.prideforex.asia/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.prideforex.asia/",
  //   base: "",
  //   MerchantRef:"7gnjiuo9",
  //   API_Key:"nlt3s35t"
  // };

  // config = {
  //   AppName: "fxcartage.io",
  //   PrimaryUrl: "https://api.fxcartage.io/Tradersroom_API_fxcartage",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxcartage.io/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxcartage.io/"
  // };

  // config = {
  //   AppName: "minoltafinance",
  //   PrimaryUrl: "https://api.minoltafinance.com/Tradersroom_API_minoltafinance",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.minoltafinance.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.minoltafinance.com/"
  // };

  // config = {
  //   AppName: "theinfinitefx",
  //   PrimaryUrl: "https://api.theinfinitefx.com/Tradersroom_API_theinfinitefx",
  // SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  // Url: "https://client.theinfinitefx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.theinfinitefx.com/"
  // };


  // config = {
  //   AppName: "loyaltyalgo",
  //   PrimaryUrl: "https://api.loyaltyalgo.com/Tradersroom_API_loyaltyalgo",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.loyaltyalgo.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.loyaltyalgo.com/"
  // };


  // config = {
  //   AppName: "v7fx.com",
  //   PrimaryUrl: "https://api.v7fx.com/Tradersroom_API_v7fx",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.v7fx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.v7fx.com/"
  // };



  // config = {
  //   AppName: "secure-future",
  //   PrimaryUrl: "https://api.secure-future-inc.com/Tradersroom_API_secure-future-inc",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.secure-future-inc.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.secure-future-inc.com/"
  // };

  //   config = {
  //   AppName: "acquatradingsolutions",
  //   PrimaryUrl: "https://api.acquatradingsolutions.com/Tradersroom_API_acquatradingsolutions",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.acquatradingsolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.acquatradingsolutions.com/"
  // };


  // config = {
  //   AppName: "Incorefx",
  //   PrimaryUrl: "https://api.incorefx.com/Tradersroom_API_incorefx",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.incorefx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.incorefx.com/"
  // };



  // config = {
  //   AppName: "educapitals",
  //   PrimaryUrl: "https://api.educapitals.com/Tradersroom_API_educapitals",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.educapitals.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.educapitals.com/"
  // };


  // config = {
  //   AppName: "orbitoforex",
  //   PrimaryUrl: "https://api.orbitoforex.com/Tradersroom_API_orbitoforex",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://eclient.orbitoforex.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://eclient.orbitoforex.com/"
  // };


  // config = {
  //   AppName: "unity-wealth",
  //   PrimaryUrl: "https://api.unity-wealth.com/Tradersroom_API_unity-wealth",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.unity-wealth.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.unity-wealth.com/"
  // };


  // config = {
  //   AppName: "unityfxpro",
  //   PrimaryUrl: "https://api.unityfxpro.com/Tradersroom_API_unityfxpro",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.unityfxpro.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.unityfxpro.com/"
  // };


  // config = {
  //   AppName: "kaizenmarkets",
  //   PrimaryUrl: "https://api.kaizenmarkets.com/Tradersroom_API_kaizenmarkets",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.kaizenmarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.kaizenmarkets.com/"
  // };


  // config = {
  //   AppName: "nexapip",
  //   PrimaryUrl: " https://api.nexapip.com/Tradersroom_API_nexapip",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://eclient.nexapip.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://eclient.nexapip.com/"
  // };


  // config = {
  //   AppName: "forexage",
  //   PrimaryUrl: "https://api.forexage.com/Tradersroom_API_forexage",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.forexage.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.forexage.com/"
  // };


  // config = {
  //   AppName: "kodincapital",
  //   PrimaryUrl: "https://api.kodincapital.com/Tradersroom_API_kodincapital",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.kodincapital.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.kodincapital.com/"
  // };

  // config = {
  //   AppName: "wayonefx",
  //   PrimaryUrl: "https://api.wayonefx.com/Tradersroom_API_wayonefx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.wayonefx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.wayonefx.com/"
  // };


  // config = {
  //   AppName: "stxbrokerz",
  //   PrimaryUrl: "https://api.stxbrokerz.com/Tradersroom_API_stxbrokerz",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://eclient.stxbrokerz.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://eclient.stxbrokerz.com/"
  // };

  // config = {
  //   AppName: "unityfxm",
  //   PrimaryUrl: "https://api.unityfxm.com/Tradersroom_API_unityfxm",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.unityfxm.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.unityfxm.com/"
  // };


  //   config = {
  //   AppName: "marginfxmarkets",
  //   PrimaryUrl: "https://api.marginfxmarkets.com/Tradersroom_API_marginfxmarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://eclient.marginfxmarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://eclient.marginfxmarkets.com/"
  // };

  //     config = {
  //   AppName: "orbitofx",
  //   PrimaryUrl: "https://api.orbitofx.co/Tradersroom_API",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://eclient.orbitofx.co/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://eclient.orbitofx.co/"
  // };


  // config = {
  //   AppName: "fxtni",
  //   PrimaryUrl: "https://apicrm.fxusolutions.com/Tradersroom_API_CrmFxusolutions",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://crm.fxusolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",.
  //   base_url:"https://crm.fxusolutions.com/"
  // };

  // config = {
  //   AppName: "securefuture",
  //   PrimaryUrl: "https://apisecurefuture.fxusolutions.com/Tradersroom_API_Securefuturefxusolutions",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: " https://securefuture.fxusolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://securefuture.fxusolutions.com/"
  // };

  // config = {
  //   AppName: "primenetcapital",
  //   PrimaryUrl: "https://api.primenetcapital.com/TradersroomAPI_primenetcapital",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.primenetcapital.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.primenetcapital.com/"
  // };

  // config = {
  //   AppName: "bigbullmarkets",
  //   PrimaryUrl: "https://api.bigbullmarkets.com/Tradersroom_API_bigbullmarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.bigbullmarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.bigbullmarkets.com/"
  // };


  // config = {
  //   AppName: "oxourventures",
  //   PrimaryUrl: " https://api.oxourventures.com/Tradersroom_API_oxourventures",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.oxourventures.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.oxourventures.com/"
  // };


  // config = {
  //   AppName: "theunityfx",
  //   PrimaryUrl: "https://api.theunityfx.com/Tradersroom_API_theunityfx",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.theunityfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.theunityfx.com/"
  // };


  // config = {
  //   AppName: "linnoxcm",
  //   PrimaryUrl: "https://api.linnoxcm.com/Tradersroom_API_linnoxcm",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.linnoxcm.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.linnoxcm.com/"
  // };

  // config = {
  //   AppName: "fxtradeos",
  //   PrimaryUrl: "https://api.fxtradeos.com/Tradersroom_API_fxtradeos",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxtradeos.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxtradeos.com/"
  // };

  //   config = {
  //   AppName: "equitiexperts",
  //   PrimaryUrl: "https://api.equitiexperts.com/Tradersroom_API_equitiexperts",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.equitiexperts.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.equitiexperts.com/"
  // };

  //     config = {
  //   AppName: "indianoctafx",
  //   PrimaryUrl: "https://api.indianoctafx.com/Tradersroom_API_indianoctafx",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.indianoctafx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.indianoctafx.com/"
  // };

  // config = {
  //   AppName: "aiauthorisedtrade",
  //   PrimaryUrl: "https://api.aiauthorisedtrade.com/Tradersroom_API_aiauthorisedtrade",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.aiauthorisedtrade.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.aiauthorisedtrade.com/"
  // };

  // config = {
  //   AppName: "ifincapitals",
  //   PrimaryUrl: "https://api.ifincapitals.com/Tradersroom_API_ifincapitals",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.ifincapitals.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.ifincapitals.com/"
  // };

  // config = {
  //   AppName: "fxtradez",
  //   PrimaryUrl: "https://api.fxtradez.com/Tradersroom_API_fxtradez",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxtradez.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxtradez.com/"
  // };


  // config = {
  //   AppName: "fxusolutions",
  //   PrimaryUrl: "https://api.fxusolutions.com/Tradersroom_API_fxusolutions",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://fxtni.fxusolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://fxtni.fxusolutions.com/"
  // };
  
  // config = {
  //   AppName: "crm_fxusolutions",
  //   PrimaryUrl: "https://api.fxtradeomarket.com/Tradersroom_API_fxtradeomarket",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://crm.fxusolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://crm.fxusolutions.com/"
  // };

  // config = {
  //   AppName: "backoffice",
  //   PrimaryUrl: "https://apibackoffice.fxusolutions.com/Tradersroom_API_BackofficeFxusolutions",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://backoffice.fxusolutions.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://backoffice.fxusolutions.com/"
  // };

  // config = {
  //   AppName: "tradesbells",
  //   PrimaryUrl: "https://api.tradesbells.com/Tradersroom_API_tradesbells",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.tradesbells.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.tradesbells.com/"
  // };

  // config = {
  //   AppName: "brcmarkets",
  //   PrimaryUrl: "https://api.brcmarkets.com/Tradersroom_API_brcmarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://trader.brcmarkets.com//assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://trader.brcmarkets.com//"
  // };

  // config = {
  //   AppName: "oorafx",
  //   PrimaryUrl: "https://api.oorafx.com/Tradersroom_API_oorafx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.oorafx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.oorafx.com/"
  // };

  // config = {
  //     AppName: "pgcfx",
  //     PrimaryUrl: "https://api.pgcfx.com/Tradersroom_API_pgcfx",
  //     //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //     SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //    Url: "https://crm.pgcfx.com/assets/PHP/alfa/v1",
  //     AdminApi: "",
  //     base_url:"https://crm.pgcfx.com/"
  //   };

   //   config = {
  //   AppName: "oora-oorafx",
  //   PrimaryUrl: "https://apioora.oorafx.com/Tradersroom_API_ooraoorafx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://oora.oorafx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://oora.oorafx.com/"
  // };



  //     config = {
  //   AppName: "fxmarvel",
  //   PrimaryUrl: "https://api.fxmarvel.com/Tradersroom_API_fxmarvel",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.fxmarvel.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.fxmarvel.com/"
  // };


  //   config = {
  //   AppName: "masterstocksfx",
  //   PrimaryUrl: "https://api.masterstocksfx.io/Tradersroom_API_masterstocksfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.masterstocksfx.io/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.masterstocksfx.io/"
  // };

  // config = {
  //   AppName: "oorafx",
  //   PrimaryUrl: "https://api.oorafx.com/Tradersroom_API_oorafx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://yousab.oorafx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://yousab.oorafx.com/"
  // };

  // config = {
  //   AppName: "leveragemarkets",
  //   PrimaryUrl: "https://api.leveragemarkets.com/Tradersroom_API_leveragemarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.leveragemarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.leveragemarkets.com/"
  // };

  // config = {
  //   AppName: "appealingfx",
  //   PrimaryUrl: "https://api.appealingfx.com/Tradersroom_API_appealingfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.appealingfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.appealingfx.com/" 
  // };

  // config = {
  //   AppName: "traderscabinet",
  //   PrimaryUrl: "http://65.21.229.130:8272/Tradersroom_API_traderscabinet",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "http://client.masterstocksfx.io/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"http://client.masterstocksfx.io/"
  
  // };
  
  // config = {
  //   AppName: "traderscabinet",
  //   PrimaryUrl: "https://api.traderscabinet.com/Tradersroom_API_traderscabinet",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.bitxtream.com/assets/PHP/alfa2/v1",
  //   AdminApi: "",
  //   base_url:"https://crm.traderscabinet.com/"
  // };

  //  config = {
  //   AppName: "traderscabinet",
  //   PrimaryUrl: "http://178.238.234.59:8291/Tradersroom_API_traderscabinet",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.bitxtream.com/assets/PHP/alfa2/v1",
  //   AdminApi: "",
  //   base_url:"https://crm.traderscabinet.com/"
  // // };

  // config = {
  //   AppName: "latharefx",
  //   PrimaryUrl: "https://api.latharefx.com/Tradersroom_API_latharefx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.latharefx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.latharefx.com/"
  // };
  

  // config = {
  //   AppName: "leveragemarkets",
  //   PrimaryUrl: "https://api.leveragemarkets.com/Tradersroom_API_leveragemarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.leveragemarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.leveragemarkets.com/"
  // };
  
  // config = {
  //   AppName: "thenimblemarkets",
  //   PrimaryUrl: "https://api.thenimblemarkets.com/Tradersroom_API_nimble",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://secure.thenimblemarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://secure.thenimblemarkets.com/"
  // };
  
  // config = {
  //   AppName: "racfx",
  //   PrimaryUrl: "https://api.racfx.com/Tradersroom_API_racfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://secure.thenimblemarkets.com/assets/PHP/alfa1/v1",
  //   AdminApi: "",
  //   base_url:"https://client.racfx.com/"
  // };

  //   config = {
  //   AppName: "symroxcapitals",
  //   PrimaryUrl: "https://api.symroxcapitals.com/Tradersroom_API_symroxcapitals",
  //   // http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.symroxcapitals.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.symroxcapitals.com/"
  // };
  

  // config = {
  //   AppName: "client panel",
  //   PrimaryUrl: "https://api.nimblefxmarkets.com/Tradersroom_API_nimblefx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.nimblefxmarkets.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.nimblefxmarkets.com/"
  // };

  // config = {
  //   AppName: "oxisxenacapital",
  //   PrimaryUrl: "https://api.platinumglobalfx.com/Tradersroom_API_platinumglobalfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.platinumglobalfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.platinumglobalfx.com/"
  // };

  // config = {
  //   AppName: "ibellmarkets",
  //   PrimaryUrl: "https://api.ibellmarkets.com/Tradersroom_API_ibellmarkets",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //   Url: "https://client.bitxtream.com/assets/PHP/alfa1/v1",
  //   AdminApi: "",
  //   base_url:"https://client.ibellmarkets.com/"
  // };

  // config = {
  //   AppName: "infiglobex",
  //   PrimaryUrl: "https://api.infiglobex.com/Tradersroom_API_infiglobex",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //   Url: "https://client.infiglobex.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.infiglobex.com/"
  // };

  // config = {
  //   AppName: "symroxcapitals",
  //   PrimaryUrl: "https://api.symroxcapitals.com/Tradersroom_API_symroxcapitals",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //   Url: "https://client.symroxcapitals.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.symroxcapitals.com/"
  // };

  
  // config = {
  //   AppName: "traderscabinet",
  //   PrimaryUrl: "https://api.traderscabinet.com/Tradersroom_API_traderscabinet",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.ibellsfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "", 
	// base_url:"https://crm.traderscabinet.com/",
  // };

  // config = {
  //   AppName: "oxisfxltd",
  //   PrimaryUrl: "https://api.oxisfxltd.com/Tradersroom_API_oxisfxltd",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.oxisfxltd.com/assets/PHP/alfa/v1",
  //   AdminApi: "", 
	// base_url:"https://client.oxisfxltd.com/",
  // };

  //   config = {
  //   AppName: "myencorefx",
  //   PrimaryUrl: "http://79.143.176.19:8265/Tradersroom_API",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "http://client.myencorefx.com/assets/PHP/alfa/v1",
  //   AdminApi: "", 
	// base_url:"http://client.myencorefx.com/",
  // };

  // config = {
  //   AppName: "vergefx",
  //   PrimaryUrl: "http://79.143.176.19:8266/Tradersroom_API",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "http://client.vergefx.co/assets/PHP/alfa/v1",
  //   AdminApi: "", 
	// base_url:"http://client.vergefx.co/",
  // };



  // config = {
  //   AppName: "oximarket",
  //   PrimaryUrl: "https://api.oximarket.com/Tradersroom_API_oximarket",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.oximarket.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.oximarket.com/"
  // };
  // config = {
  //   AppName: "wizardcapitals",
  //   PrimaryUrl: "https://api.wizardcapitals.com/Tradersroom_API_wizardcapitals",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.wizardcapitals.com/assets/PHP/alfa/v1",
  //   AdminApi: "", 
	// base_url:"https://client.wizardcapitals.com",
  // };
  
  // config = {
  //   AppName: "Platinumglobalfx",
  //   PrimaryUrl: "https://api.platinumglobalfx.com/Tradersroom_API_platinumglobalfx",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.platinumglobalfx.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.platinumglobalfx.com/"
  // };

  // config = {
  //   AppName: "Symroxcapitals",
  //   PrimaryUrl: "https://api.symroxcapitals.com/Tradersroom_API_symroxcapitals",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.symroxcapitals.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.symroxcapitals.com/"
  // };
 
  // config = {
  //   AppName: "Atalia",
  //   PrimaryUrl: "https://api.atallia.us/Tradersroom_API_atallia",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.atallia.us/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.atallia.us/"
  // };

  // config = {
  //   AppName: "platinumfx",
  //   PrimaryUrl: "http://5.189.170.190:8251/Tradersroom_API",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "http://client.platinumfx.io/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"http://client.platinumfx.io/"
  // };
// https://api.traderscabinet.com/Tradersroom_API_traderscabinet/
  // config = {
  //     AppName: "platinumfx",
  //     PrimaryUrl: "https://api.platinumfx.io/Tradersroom_API_platinumfx",
  //     //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //     SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //    Url: "https://secure.platinumfx.io/assets/PHP/alfa/v1",
  //     AdminApi: "",
  //     base_url:"https://secure.platinumfx.io/"
  //   };
  // config = {
  //   AppName: "platinumfx",
  //   PrimaryUrl: "https://api.traderscabinet.com/Tradersroom_API_traderscabinet/",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://secure.platinumfx.io/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://secure.platinumfx.io/"
  // };
  // config = {
  //   AppName: "Gamaforex",
  //   PrimaryUrl: "https://api.gamaforex.com/Tradersroom_API_gamaforex",
  //   //http://79.143.176.19:8160/Tradersroom_API_tradeUK PrimaryUrlhttps://api.xmbfx.com/TraderroomAPI_xmbfx:  https://api.xmbfx.com/TraderroomAPI_xmbfx "https://api.investotrade.net/Tradersroom_API_investotradehttp://185.2.103.78:8154/Tradersroom_DevAPI",
  //   SecondaryUrl: "http://178.238.234.59:9301/SignalHubAPI",
  //  Url: "https://client.gamaforex.com/assets/PHP/alfa/v1",
  //   AdminApi: "",
  //   base_url:"https://client.gamaforex.com/"
  // };

  // https://apicrm.traderscabinet.com/Tradersroom_API_Traderscnt   MAIN SERVICE URL
   // config = {
  //   AppName: "ExchAdmin2",
  //   PrimaryUrl: "http://173.249.4.244:3000/tradeuk",
  //   SecondaryUrl: "http://173.249.4.244:3000/tradeuksignal",
  //   Url: "http://207.180.199.14:8021/assets/PHP/alfa/v1",
  //   AdminApi: ""
  // };
  SSL: boolean;
  constructor(public http: HttpClient, protected conf: ConfigService) {
    // this.SSL = this.Service.SSL;
    // this.config.AppName = 'MSC Admin';
    // this.config.PrimaryUrl = (this.Service.SSL ? 'https' : 'http') + '://' + this.Service.IP + (this.Service.LIVE ? '' : ':' + this.Service.PORTS[7]) + '/' + this.Service.END_POINT;
    // this.config.AdminApi = (this.Service.SSL ? 'https' : 'http') + '://' + this.Service.ADMIN + (this.Service.LIVE ? '' : ':' + this.Service.PORTS[7]);
  }

  async readConfig() {
    return new Promise(resolve => {
      try {
        this.readJSON("config.json").subscribe(
          data => {
            resolve(data);
          },
          err => {
            console.error("Initilisation Failed", err);
            resolve(null);
          }
        );
      } catch (e) {
        console.error("Error", e);
        resolve(null);
      }
    });
  }

  readJSON(param) {
    try {
      return this.http
        .get("./assets/" + param)
    } catch (e) {
      console.log(e);
    }
  }

  // async getWalletAmount(){

  //   var obj ={
  //     sWalletId:this.global.localDealerwallet
  //   }
  //   return new Promise(resolve => {
  //     try{
  //       return this.global.getWalletInfo(obj).subscribe(data => {
  //         resolve(data)
  //       }, err => {
  //         console.error('Initilisation Failed', err);
  //         resolve(null)
  //       })
  //     } catch (e) {
  //       console.error('Error', e);
  //       resolve(null);
  //     }
  //   })
  // }

  GetMethod(param: string) {
    return this.http.get(param);
  }

  Get(endPointg: string, params?: any, optn: any = "AdminApi") {
    let p = [];
    let newParam;
    if (params) {
      for (let k in params) {
        let str = k + "=" + params[k];
        p.push(str);
      }
      newParam = p.join("&");
    }
    try {
      let url = this.config[optn];
      return this.http
        .get<any>(url + "/" + endPointg + "?" + newParam);
    } catch (e) {
      console.log(e);
    }
  }

  Post(endPointg: string, params?: any, optn: any = "AdminApi") {
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    try {
      let url = this.config[optn];
      return this.http
        .post<any>(url + "/" + endPointg, params);
    } catch (e) {
      console.log(e);
    }
  }

  get(endPointg: string, params?: any, optn?: any) {
    console.log(params);
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    const p: any[] = [];
    let newParam;
    if (params) {
      for (let k in params) {
        let str = k + "=" + params[k];
        p.push(str);
      }
      newParam = p.join("&");
    }
    try {
      return this.http
        .get<any>(this.config.PrimaryUrl + "/" + endPointg + "?" + newParam);
    } catch (e) {
      console.log(e);
    }
  }

  getp(optn?: any) {
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    let p = [];
    let newParam;

    try {
      return this.http
        .get<any>(
          "https://free.currconv.com/api/v7/convert?q=USD_INR&compact=ultra&apiKey=ca0f50b09cfee08f2876"
        );
    } catch (e) {
      console.log(e);
    }
  }

  post(endPointg: string, params?: any, optn?: any) {
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    try {
      return this.http
        .post<any>(this.config.PrimaryUrl + "/" + endPointg, params);
    } catch (e) {
      console.log(e);
    }
  }

  get1(endPointg: string, params?: any, optn?: any) {
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    let p = [];
    let newParam;
    if (params) {
      for (let k in params) {
        let str = k + "=" + params[k];
        p.push(str);
      }
      newParam = p.join("&");
    }
    try {
      return this.http
        .get<any>(this.config.SecondaryUrl + "/" + endPointg + "?" + newParam);
    } catch (e) {
      console.log(e);
    }
  }

  post1(endPointg: string, params?: any, optn?: any) {
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    try {
      return this.http
        .post<any>(this.config.SecondaryUrl + "/" + endPointg, params);
    } catch (e) {
      console.log(e);
    }
  }

  webSocket(domain: string, param?: any) {
    var fws = new WebSocket(domain);
    fws.onopen = function() {
      fws.send(param); /* Send the message 'Ping' to the server*/
    };
    return fws;
  }

  post2(endPointg: string, params?: any, optn?: any) {
    if (!optn) {
      optn = { params: new HttpParams() };
    }
    try {
      return this.http
        .post<any>(this.config.Url + "/" + endPointg, params);
    } catch (e) {
      console.log(e);
    }
  }
}
